import React, { useEffect, useState } from 'react';
import Loading from '../loading/Loading'
import Swal from 'sweetalert2';
import ToggleSwitch from '../advertisement/ToggleSwitch';
import axios from 'axios';
import {
    Typography, TablePagination,
    Table, TableBody, TableCell,
    TableHead, TableRow, TableContainer,
} from "@mui/material";

function AdminGarageList({ garagesList, actions }) {
    const [garages, setGarages] = useState([]);
    const [loading, setLoading] = useState(true);

    const [loadingText, setLoadingText] = useState('Loading Advertisement, Please Wait...')

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [searchInput, setSearchInput] = useState('');
    const [filteredGarages, setFilteredGarages] = useState([]);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleSearch = () => {
        const filtered = garagesList.filter((garage) => {
            const searchValue = searchInput.toLowerCase();

            // Define the properties you want to search in
            const searchProperties = [
                garage.ownerEmail,
                garage.address,
                garage.city,
                garage.state,
                garage.zipCode,
                garage.length,
                garage.width,
                garage.mainDoorHeight,
                garage.mainDoorWidth,
                garage.electricalOutlets110V,
                garage.electricalOutlets220V,
                garage.heated,
                garage.description,
                garage.rentalRate,
                garage.deposit,
                garage.lateCharge,
                garage.bounceFee,
            ];

            // Check if any property contains the search input
            return searchProperties.some((property) => {
                if (typeof property === 'string' && property.toLowerCase().includes(searchValue)) {
                    return true; // Property is a string and contains the search value
                } else if (typeof property === 'number' && property.toString().includes(searchValue)) {
                    return true; // Property is a number and contains the search value
                }
                return false;
            });
        });

        setFilteredGarages(filtered);
    };


    const garagesToDisplay = searchInput ? filteredGarages : garagesList;
    const usersToShow = garagesToDisplay.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    //const usersToShow = garagesList.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    useEffect(() => {

        if (garagesList && Object.keys(garagesList).length) {
            const getGaragesComponents = (garage, element) => {


                // console.log(garage)

            };

            async function getGarages(garagesList) {
                let garagesContainer = [];
                try {
                    for (const garage in garagesList) {
                        const element = garagesList[garage];
                        garagesContainer.push(getGaragesComponents(garage, element));
                    }
                    return garagesContainer;
                } catch (error) {
                    throw error;
                }
            }

            getGarages(garagesList).then(resp => {
                //console.log('Garages results', resp);
                setGarages(() => [
                    resp
                ]);

                if (resp.length > 0) {
                    setLoading(false);
                } else {
                    setLoading(true);
                    setLoadingText("Oops, no garages found");
                }
            });
        } else {
            setGarages(() => { });
            setLoading(() => false);
            // setLoadingText("Loading...");
        }
    }, [garagesList, actions])


    function approveFun(key, ToggleValue) {
        const originalUserStatus = ToggleValue;
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to ${ToggleValue ? 'disable' : 'enable'} this garage!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, ${ToggleValue ? 'disable' : 'enable'} it!`
        }).then(async (result) => {
            if (result.value) {
                axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'UpdateGarageStatus', status: !ToggleValue, id: key })
                    .then(response => {
                        Swal.fire(
                            'success',
                            response.data.message,
                            'success'
                        )
                    })
                    .catch(error => {
                        Swal.fire(
                            'There were a problem',
                            error ? 'Error fetching data:' + error : 'Please, try again or contact SAGE Parents',
                            'error'
                        )
                        console.error('Error fetching data:', error);
                    });

            } else {
                // setGaragesopen((prevGarages) =>
                //   prevGarages.map((garage) =>
                //     garage.id === key ? { ...garage, userStatus: originalUserStatus } : garage
                //   )
                // );
            }
        })
    }


    return (loading ?
        <Loading text={loadingText} />
        :
        <>
            <div className="col-md-12 d-flex">
                <input
                    className='form-control w-25 mx-2 py-2'
                    type="text"
                    placeholder="Search Garages"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                />
                <button onClick={handleSearch}
                    className='btn btn-outline-success  py-2'>Search</button>
            </div>
            <TableContainer
                className='table'
                sx={{
                    width: {
                        xs: "274px",
                        sm: "100%",
                    },
                }}
            >
                <Table
                    aria-label="simple table"
                    sx={{
                        whiteSpace: "nowrap",
                        mt: 2,
                    }}
                >
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography color="textSecondary" variant="h6">Image
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography color="textSecondary" variant="h6">Address
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography color="textSecondary" variant="h6">Dimensions
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography color="textSecondary" variant="h6">Features
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography color="textSecondary" variant="h6">Pricing
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography color="textSecondary" variant="h6">Status
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {usersToShow.map((element, index) => (
                            <TableRow key={index}>
                                <TableCell className="image-ads">
                                    <img width={300} className="garage__image" src={`${element.garagePictures[0] ? `${process.env.REACT_APP_UPLOAD_URL + element.garagePictures[0]}` : './assets/Images/garage-placeholder.png'}`} alt='imagesURL'></img>
                                </TableCell>

                                <TableCell>
                                    <Typography color="textSecondary">
                                    Owner Email : {element.ownerEmail ? element.ownerEmail : ''}<br />
                                        Address : {element.address ? element.address : ''}<br />
                                        City : {element.city ? element.city : ''}<br />
                                        State : {element.state ? element.state : ''}<br />
                                        zipCode : {element.zipCode ? element.zipCode : ''}
                                    </Typography>
                                </TableCell>

                                <TableCell>
                                    <Typography color="textSecondary">
                                        Length : {element.length ? element.length : ''}<br />
                                        Width : {element.width ? element.width : ''}<br />
                                        Main Door Height : {element.mainDoorHeight ? element.mainDoorHeight : ''}<br />
                                        Main Door Width : {element.mainDoorWidth ? element.mainDoorWidth : ''}
                                    </Typography>
                                </TableCell>

                                <TableCell>
                                    <Typography color="textSecondary">
                                        110V Electrical Outlets : {element.electricalOutlets110V ? element.electricalOutlets110V : ''}<br />
                                        220V Electrical Outlets : {element.electricalOutlets220V ? element.electricalOutlets220V : ''}<br />
                                        Heated : {element.heated ? element.heated : ''}<br />
                                        Description : <span style={{ textWrap: 'balance' }}>{element.description ? element.description : ''}</span>
                                    </Typography>
                                </TableCell>

                                <TableCell>
                                    <Typography color="textSecondary">
                                        Rental Rate : {element.rentalRate ? element.rentalRate : ''}<br />
                                        Deposit : {element.deposit ? element.deposit : ''}<br />
                                        Late Charge : {element.lateCharge ? element.lateCharge : ''}<br />
                                        Bounce Fee : {element.bounceFee ? element.bounceFee : ''}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography color="textSecondary" className="garage__label">
                                        {element.status === 0 ? ' Disable by User' : ''}</Typography>
                                    <React.Fragment>
                                        <ToggleSwitch
                                            onlabel="Enabled"
                                            offlabel="Disabled"
                                            onClick={() => approveFun(element.id, element.status === 1 || element.status === 0 ? true : false)}
                                            checked={element.status === 1 || element.status === 0 ? true : false} />
                                    </React.Fragment>



                                </TableCell>

                            </TableRow>

                        ))}
                    </TableBody>
                </Table>
            </TableContainer >
            <TablePagination
                component="div"
                count={garagesList.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>



    )
}

export default AdminGarageList